import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfirmComponent } from '@app/shared/confirm/confirm.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [ConfirmComponent],
  imports: [CommonModule, TranslateModule, MatIconModule, MatDialogModule],
  exports: [ConfirmComponent],
})
export class ConfirmModule {}
